var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-container"},[_c('input',{staticClass:"slider",style:({
      background: _vm.background,
      '--tumb-background': _vm.thumbColor
    }),attrs:{"title":_vm.value + ' km',"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onInput($event.target)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }